import React, { useEffect, useState } from "react";
import "./quickviewProductDetails.css";

const SizeButtons = ({ productVarientsData, onChangeVaraiant }) => {
  
  const [selected, setSelected] = useState(null); 
  useEffect(() => {
    setSelected(productVarientsData[0]?.variant_map_id);
  }, [productVarientsData]);
useEffect(()=>{
  onChangeVaraiant(selected);

},[selected])
  const handleButtonClick = (index, data) => {
    setSelected(index);
    // onChangeVaraiant(data);
  };
  return (
    <div className="d-flex  flex-wrap gap-3 my-3">
      {productVarientsData?.length > 0 &&
        productVarientsData?.map((button) => (
          <button
            key={button?.variant_map_id}
            className={`quick-view-button ${
              selected === button?.variant_map_id ? "selected" : ""
            } border-1`}
            onClick={() => handleButtonClick(button?.variant_map_id, button)}
          >
            {button?.value}
          </button>
        ))}
    </div>
  );
};

export default SizeButtons;
